import {request} from '@/utils/request'
import qs from 'qs'

export async function apiUploadFile(url, params, cb) {
	return request(url, {
		method: 'POST',
		data: params,
		onUploadProgress: function(progress) {
			cb && cb(progress)
		}
	})
}

export async function apiGet(url, params) {
	// 增加时间戳 防止缓存
	if (params) {
		params.__t = Date.now()
	} else {
		params = {
			__t: Date.now()
		}
		// 如果路径传参了，就抽出来统一处理
		if (url && url.indexOf('?') !== -1) {
			params = { ...params, ...qs.parse(url.split('?')[1]) }
			url = url.split('?')[0]
		}
	}
	const queryString = qs.stringify(params, {
		arrayFormat: 'repeat',
		skipNulls: true,
		addQueryPrefix: true
	})
	return request(`${url}${queryString}`)
}

export async function apiPost(url, params) {
	return request(url, {
		method: 'POST',
		data: params
	})
}
